import ExampleQuestionItem from "./example-question-item";
import { Text } from "../ui/text";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { useOutsideClick } from "@/hooks/shared/use-outside-click";
import { EXAMPLE_QUESTIONS } from "@/constants/ai-agent";
import { useAiAgentStore } from "@/stores/ai-agent";

const ExampleQuestionList = () => {
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(-1);

  const containerRef = useOutsideClick(() => setSelectedQuestionIndex(-1));

  const { setMessage } = useAiAgentStore();

  const handleQuestionClick = (index: number) => {
    setMessage(EXAMPLE_QUESTIONS[selectedQuestionIndex].examples[index]);
  };

  return (
    <div
      className="flex flex-col gap-[10px] items-center relative"
      ref={containerRef}
    >
      <div className="flex gap-[10px] justify-center">
        {EXAMPLE_QUESTIONS.map((question, index) => (
          <ExampleQuestionItem
            key={question.title}
            question={question}
            onClick={(index: number) => setSelectedQuestionIndex(index)}
            index={index}
            selectedQuestionIndex={selectedQuestionIndex}
          />
        ))}
      </div>
      {selectedQuestionIndex !== -1 && (
        <div
          className="absolute top-[50px] left-[50%] translate-x-[-50%] rounded-[8px] px-4 pt-5 pb-6 w-[664px]"
          style={{
            background: "rgba(255, 255, 255, 0.50)",
            boxShadow: "0 4px 10px 0 rgba(55, 55, 55, 0.05)",
          }}
        >
          <div className="flex flex-col gap-[2px]">
            {EXAMPLE_QUESTIONS[selectedQuestionIndex].examples.map(
              (example, index) => (
                <div
                  key={index}
                  onClick={() => handleQuestionClick(index)}
                  className={cn(
                    "cursor-pointer px-4 border-b border-grey-90 pb-2 pt-2",
                    index ===
                      EXAMPLE_QUESTIONS[selectedQuestionIndex].examples.length -
                        1 && "border-b-0 pb-0",
                    index === 0 && "pt-0"
                  )}
                >
                  <Text variant={"label-lg"} className="text-grey-20">
                    {example}
                  </Text>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExampleQuestionList;
